import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTimeISO: any;
  JSON: any;
  ObjectId: any;
  Upload: any;
};

export type Admin = CollectionDataInterface & {
  __typename?: 'Admin';
  _id: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type Boucher = {
  __typename?: 'Boucher';
  file?: Maybe<File>;
  subText: Scalars['JSON'];
  title: Scalars['JSON'];
};

export type BoucherInput = {
  file?: InputMaybe<FileDocInput>;
  subText: Scalars['JSON'];
  title: Scalars['JSON'];
};

export enum Category {
  Attractions = 'Attractions',
  Cafe = 'Cafe',
  Convention = 'Convention'
}

export type CollectionDataInterface = {
  _id: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type Coupon = CollectionDataInterface & {
  __typename?: 'Coupon';
  _id: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  itemId?: Maybe<Scalars['String']>;
  photo?: Maybe<File>;
  subText: Scalars['JSON'];
  title: Scalars['JSON'];
  totalUsed?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTimeISO'];
  used?: Maybe<Scalars['Float']>;
};

export type CouponInput = {
  itemId?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<FileDocInput>;
  subText: Scalars['JSON'];
  title: Scalars['JSON'];
  totalUsed?: InputMaybe<Scalars['Float']>;
  used?: InputMaybe<Scalars['Float']>;
};

export type CouponResponse = {
  __typename?: 'CouponResponse';
  data?: Maybe<Coupon>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type DetailLocation = {
  __typename?: 'DetailLocation';
  address?: Maybe<Scalars['String']>;
  addressDetail?: Maybe<Scalars['String']>;
  addressEnglish?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  apartment?: Maybe<Scalars['String']>;
  autoJibunAddress?: Maybe<Scalars['String']>;
  autoJibunAddressEnglish?: Maybe<Scalars['String']>;
  autoRoadAddress?: Maybe<Scalars['String']>;
  autoRoadAddressEnglish?: Maybe<Scalars['String']>;
  bcode?: Maybe<Scalars['String']>;
  bname?: Maybe<Scalars['String']>;
  bname1?: Maybe<Scalars['String']>;
  bname1English?: Maybe<Scalars['String']>;
  bname2?: Maybe<Scalars['String']>;
  bname2English?: Maybe<Scalars['String']>;
  bnameEnglish?: Maybe<Scalars['String']>;
  buildingCode?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  hname?: Maybe<Scalars['String']>;
  jibunAddress?: Maybe<Scalars['String']>;
  jibunAddressEnglish?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  /** lat,lng */
  latLng?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  noSelected?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  postcode1?: Maybe<Scalars['String']>;
  postcode2?: Maybe<Scalars['String']>;
  postcodeSeq?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  roadAddress?: Maybe<Scalars['String']>;
  roadAddressEnglish?: Maybe<Scalars['String']>;
  roadname?: Maybe<Scalars['String']>;
  roadnameCode?: Maybe<Scalars['String']>;
  roadnameEnglish?: Maybe<Scalars['String']>;
  sido?: Maybe<Scalars['String']>;
  sidoEnglish?: Maybe<Scalars['String']>;
  sigungu?: Maybe<Scalars['String']>;
  sigunguCode?: Maybe<Scalars['String']>;
  sigunguEnglish?: Maybe<Scalars['String']>;
  userLanguageType?: Maybe<Scalars['String']>;
  userSelectedType?: Maybe<Scalars['String']>;
  zonecode?: Maybe<Scalars['String']>;
};

export type DetailLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  addressDetail?: InputMaybe<Scalars['String']>;
  addressEnglish?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  apartment?: InputMaybe<Scalars['String']>;
  autoJibunAddress?: InputMaybe<Scalars['String']>;
  autoJibunAddressEnglish?: InputMaybe<Scalars['String']>;
  autoRoadAddress?: InputMaybe<Scalars['String']>;
  autoRoadAddressEnglish?: InputMaybe<Scalars['String']>;
  bcode?: InputMaybe<Scalars['String']>;
  bname?: InputMaybe<Scalars['String']>;
  bname1?: InputMaybe<Scalars['String']>;
  bname1English?: InputMaybe<Scalars['String']>;
  bname2?: InputMaybe<Scalars['String']>;
  bname2English?: InputMaybe<Scalars['String']>;
  bnameEnglish?: InputMaybe<Scalars['String']>;
  buildingCode?: InputMaybe<Scalars['String']>;
  buildingName?: InputMaybe<Scalars['String']>;
  hname?: InputMaybe<Scalars['String']>;
  jibunAddress?: InputMaybe<Scalars['String']>;
  jibunAddressEnglish?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  /** lat,lng */
  latLng?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['Float']>;
  noSelected?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  postcode1?: InputMaybe<Scalars['String']>;
  postcode2?: InputMaybe<Scalars['String']>;
  postcodeSeq?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  roadAddress?: InputMaybe<Scalars['String']>;
  roadAddressEnglish?: InputMaybe<Scalars['String']>;
  roadname?: InputMaybe<Scalars['String']>;
  roadnameCode?: InputMaybe<Scalars['String']>;
  roadnameEnglish?: InputMaybe<Scalars['String']>;
  sido?: InputMaybe<Scalars['String']>;
  sidoEnglish?: InputMaybe<Scalars['String']>;
  sigungu?: InputMaybe<Scalars['String']>;
  sigunguCode?: InputMaybe<Scalars['String']>;
  sigunguEnglish?: InputMaybe<Scalars['String']>;
  userLanguageType?: InputMaybe<Scalars['String']>;
  userSelectedType?: InputMaybe<Scalars['String']>;
  zonecode?: InputMaybe<Scalars['String']>;
};

/** S3 업로드된 파일... */
export type File = CollectionDataInterface & {
  __typename?: 'File';
  _id: Scalars['String'];
  blur?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeISO'];
  description?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  fileType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  tags: Array<Tag>;
  type?: Maybe<FileType>;
  updatedAt: Scalars['DateTimeISO'];
  uri: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  viewCnt?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type FileDocInput = {
  blur?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  extension?: Scalars['String'];
  fileType?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  name?: Scalars['String'];
  tags: Array<TagInput>;
  type?: InputMaybe<FileType>;
  uri?: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  viewCnt?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

/** 날파일 올릴때 사용 File upload to s3 이후에는 FileCreateInput 으로 임베딩 */
export type FileInput = {
  blur?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  tags?: Array<TagInput>;
  upload: Scalars['Upload'];
  width?: InputMaybe<Scalars['Float']>;
};

export enum FileType {
  Short = 'Short'
}

export type FileUploadsResponse = {
  __typename?: 'FileUploadsResponse';
  data: Array<File>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** Display error to client-side. */
export type InputError = {
  __typename?: 'InputError';
  code: Scalars['String'];
  /** 다음과 같은 포멧으로 출력됨 => ${FIELD}: ${VALIDATION_FAIL_MESSAGE} */
  details?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type Item = CollectionDataInterface & {
  __typename?: 'Item';
  _id: Scalars['String'];
  address?: Maybe<Scalars['JSON']>;
  addressDetail?: Maybe<DetailLocation>;
  boothId?: Maybe<Scalars['String']>;
  bouchers?: Maybe<Array<Boucher>>;
  categoryKey?: Maybe<Category>;
  contact?: Maybe<Scalars['String']>;
  coupon?: Maybe<Array<Coupon>>;
  createdAt: Scalars['DateTimeISO'];
  image: Array<File>;
  information: Scalars['JSON'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  name: Scalars['JSON'];
  shorts?: Maybe<Array<File>>;
  thumb?: Maybe<Scalars['String']>;
  type: ItemType;
  updatedAt: Scalars['DateTimeISO'];
};

export type ItemCreateResponse = {
  __typename?: 'ItemCreateResponse';
  data?: Maybe<Item>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ItemDeleteResponse = {
  __typename?: 'ItemDeleteResponse';
  data?: Maybe<Item>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ItemInput = {
  address?: InputMaybe<Scalars['JSON']>;
  addressDetail?: InputMaybe<DetailLocationInput>;
  boothId?: InputMaybe<Scalars['String']>;
  bouchers?: InputMaybe<Array<BoucherInput>>;
  categoryKey?: InputMaybe<Category>;
  contact?: InputMaybe<Scalars['String']>;
  coupon?: InputMaybe<Array<CouponInput>>;
  image: Array<FileDocInput>;
  information: Scalars['JSON'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['JSON'];
  shorts?: InputMaybe<Array<FileDocInput>>;
  type: ItemType;
};

export type ItemMap = {
  __typename?: 'ItemMap';
  _id: Scalars['String'];
  boothId: Scalars['String'];
  categoryKey: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  name: Scalars['String'];
};

export enum ItemType {
  Booth = 'BOOTH',
  Spot = 'SPOT'
}

export type ItemUpdateResponse = {
  __typename?: 'ItemUpdateResponse';
  data?: Maybe<Item>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  CouponUse: CouponResponse;
  FileDeletes: Response;
  FileUploads: FileUploadsResponse;
  ItemCreate: ItemCreateResponse;
  ItemDelete: ItemDeleteResponse;
  ItemUpdate: ItemUpdateResponse;
  LangSet: UserUpdateResponse;
  SignIn: SignInResponse;
  SystemNotiCreate: SystemNotiCreateResponse;
  SystemNotiHide: SystemNotiHideResponse;
  SystemNotiRead: SystemNotiReadResponse;
  UserDelete: UserDeleteResponse;
  UserUpdate: UserUpdateResponse;
  VisitCreate: VisitCreateResponse;
  VisitDelete: VisitDeleteResponse;
  VisitUpdate: VisitUpdateResponse;
};


export type MutationCouponUseArgs = {
  couponId: Scalars['String'];
  itemId: Scalars['String'];
};


export type MutationFileDeletesArgs = {
  deleteFileList: Array<Scalars['ObjectId']>;
};


export type MutationFileUploadsArgs = {
  files: Array<FileInput>;
  gallery?: InputMaybe<Scalars['Boolean']>;
  noImg?: InputMaybe<Scalars['Boolean']>;
};


export type MutationItemCreateArgs = {
  input: ItemInput;
};


export type MutationItemDeleteArgs = {
  itemId: Scalars['String'];
};


export type MutationItemUpdateArgs = {
  input: ItemInput;
  itemId: Scalars['String'];
};


export type MutationLangSetArgs = {
  langCode: Scalars['String'];
};


export type MutationSignInArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
};


export type MutationSystemNotiCreateArgs = {
  message: Scalars['String'];
  serverity?: InputMaybe<SystemNotiSeverity>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSystemNotiHideArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationSystemNotiReadArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationUserDeleteArgs = {
  userId: Scalars['String'];
};


export type MutationUserUpdateArgs = {
  input: UserInput;
  userId: Scalars['String'];
};


export type MutationVisitCreateArgs = {
  input: VisitInput;
};


export type MutationVisitDeleteArgs = {
  visitId: Scalars['String'];
};


export type MutationVisitUpdateArgs = {
  input: VisitInput;
  visitId: Scalars['String'];
};

export type OffsetPagenatedFileData = {
  __typename?: 'OffsetPagenatedFileData';
  items: Array<File>;
  pageInfo?: Maybe<OffsetPagingInfo>;
};

export type OffsetPagenatedItemData = {
  __typename?: 'OffsetPagenatedItemData';
  items: Array<Item>;
  pageInfo?: Maybe<OffsetPagingInfo>;
};

export type OffsetPagenatedSystemNotiData = {
  __typename?: 'OffsetPagenatedSystemNotiData';
  items: Array<SystemNoti>;
  pageInfo?: Maybe<OffsetPagingInfo>;
};

export type OffsetPagenatedUserData = {
  __typename?: 'OffsetPagenatedUserData';
  items: Array<User>;
  pageInfo?: Maybe<OffsetPagingInfo>;
};

export type OffsetPagenatedVisitData = {
  __typename?: 'OffsetPagenatedVisitData';
  items: Array<Visit>;
  pageInfo?: Maybe<OffsetPagingInfo>;
};

export type OffsetPagingInfo = {
  __typename?: 'OffsetPagingInfo';
  /** 현재 페이지에서 출력한 데이터 수 */
  currentItemCount: Scalars['Int'];
  /** 선택한 페이지 번호 */
  pageIndex: Scalars['Int'];
  /** 페이지당 기준 데이터 수 */
  pageItemCount: Scalars['Int'];
  /** 전체 아이템 수 */
  totalDocumentCount: Scalars['Int'];
  /** 전체 페이지 수 */
  totalPageCount: Scalars['Int'];
};

export type OffsetPagingInput = {
  pageIndex: Scalars['Int'];
  pageItemCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  /** 관리계정용 */
  Admin?: Maybe<Admin>;
  FileList: OffsetPagenatedFileData;
  ItemFindBy?: Maybe<Item>;
  ItemFindById?: Maybe<Item>;
  ItemFindByPath?: Maybe<Item>;
  ItemFindByStoreId?: Maybe<Item>;
  /** Function for Exam Admin */
  ItemList: OffsetPagenatedItemData;
  ItemMap: Array<ItemMap>;
  ServiceItemFind?: Maybe<Item>;
  ServiceVisitFind?: Maybe<Visit>;
  SystemNotiList: OffsetPagenatedSystemNotiData;
  UnReadNoties: Array<Scalars['String']>;
  UserCreateOrFind: UserCreateOrFindResponse;
  UserFindById?: Maybe<User>;
  UserFindByNfcId?: Maybe<User>;
  /** Function for Exam Admin */
  UserList: OffsetPagenatedUserData;
  VisitFindBy?: Maybe<Visit>;
  VisitFindById?: Maybe<Visit>;
  VisitFindByPath?: Maybe<Visit>;
  VisitFindByStoreId?: Maybe<Visit>;
  /** Function for Exam Admin */
  VisitList: OffsetPagenatedVisitData;
};


export type QueryFileListArgs = {
  filter?: InputMaybe<_FileFilter>;
  pagingInput: OffsetPagingInput;
  sort?: InputMaybe<Array<_FileSort>>;
};


export type QueryItemFindByArgs = {
  key: Scalars['String'];
};


export type QueryItemFindByIdArgs = {
  itemId: Scalars['String'];
  selectAll: Scalars['Boolean'];
};


export type QueryItemFindByPathArgs = {
  path: Scalars['String'];
};


export type QueryItemFindByStoreIdArgs = {
  storeId: Scalars['String'];
};


export type QueryItemListArgs = {
  filter?: InputMaybe<_ItemFilter>;
  pagingInput: OffsetPagingInput;
  sort?: InputMaybe<Array<_ItemSort>>;
};


export type QueryItemMapArgs = {
  filter?: InputMaybe<_ItemFilter>;
  sort?: InputMaybe<Array<_ItemSort>>;
};


export type QuerySystemNotiListArgs = {
  filter?: InputMaybe<_SystemNotiFilter>;
  pagingInput: OffsetPagingInput;
  sort?: InputMaybe<Array<_SystemNotiSort>>;
};


export type QueryUserCreateOrFindArgs = {
  input: UserInput;
};


export type QueryUserFindByIdArgs = {
  userId: Scalars['String'];
};


export type QueryUserFindByNfcIdArgs = {
  nfcId: Scalars['String'];
};


export type QueryUserListArgs = {
  filter?: InputMaybe<_UserFilter>;
  pagingInput: OffsetPagingInput;
  sort?: InputMaybe<Array<_UserSort>>;
};


export type QueryVisitFindByArgs = {
  key: Scalars['String'];
};


export type QueryVisitFindByIdArgs = {
  visitId: Scalars['String'];
};


export type QueryVisitFindByPathArgs = {
  path: Scalars['String'];
};


export type QueryVisitFindByStoreIdArgs = {
  storeId: Scalars['String'];
};


export type QueryVisitListArgs = {
  filter?: InputMaybe<_VisitFilter>;
  pagingInput: OffsetPagingInput;
  sort?: InputMaybe<Array<_VisitSort>>;
};

export type Response = {
  __typename?: 'Response';
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SignInResponse = {
  __typename?: 'SignInResponse';
  data?: Maybe<Admin>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SystemNoti = CollectionDataInterface & {
  __typename?: 'SystemNoti';
  _id: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeISO'];
  /** 히든 처리시킨 유저들, 하이드 된 노티는 관리자만 확인가능함 */
  hideUsers: Array<Scalars['ID']>;
  /** 시스템에서 운용할때 필요한 기타정보 */
  info?: Maybe<SystemNotiInfo>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isRead: Scalars['Boolean'];
  /** 읽은 유저들 목록 */
  readUsers: Array<Scalars['ID']>;
  severity: SystemNotiSeverity;
  type: SystemNotiType;
  updatedAt: Scalars['DateTimeISO'];
  /** 알림 대상 유저 아이디들 */
  users: Array<Scalars['ID']>;
};

export type SystemNotiCreateResponse = {
  __typename?: 'SystemNotiCreateResponse';
  data?: Maybe<SystemNoti>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SystemNotiHideResponse = {
  __typename?: 'SystemNotiHideResponse';
  data?: Maybe<SystemNoti>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type SystemNotiInfo = {
  __typename?: 'SystemNotiInfo';
  couponName?: Maybe<Scalars['JSON']>;
  itemCategory?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['JSON']>;
};

export type SystemNotiReadResponse = {
  __typename?: 'SystemNotiReadResponse';
  data?: Maybe<SystemNoti>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

/** 시스템 노티피케이션 심각도 */
export enum SystemNotiSeverity {
  Normal = 'Normal',
  Serious = 'Serious'
}

/** 시스템 노티피케이션 타입 */
export enum SystemNotiType {
  Coupon = 'Coupon',
  Start = 'Start',
  Visit = 'Visit'
}

/** 태그 */
export type Tag = {
  __typename?: 'Tag';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type TagInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type User = CollectionDataInterface & {
  __typename?: 'User';
  Visits?: Maybe<Array<Visit>>;
  _id: Scalars['String'];
  age?: Maybe<Scalars['String']>;
  busiCard?: Maybe<File>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeISO'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  langeCode?: Maybe<Scalars['String']>;
  mid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nfcId?: Maybe<Scalars['String']>;
  signed?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  unReadSystemNoties?: Maybe<Array<Scalars['ObjectId']>>;
  updatedAt: Scalars['DateTimeISO'];
  useCoupon?: Maybe<Array<Coupon>>;
  visitCnt?: Maybe<Scalars['Float']>;
};

export type UserCreateOrFindResponse = {
  __typename?: 'UserCreateOrFindResponse';
  data?: Maybe<User>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UserDeleteResponse = {
  __typename?: 'UserDeleteResponse';
  data?: Maybe<User>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UserInput = {
  age?: InputMaybe<Scalars['String']>;
  busiCard?: InputMaybe<FileDocInput>;
  country?: InputMaybe<Scalars['String']>;
  mid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nfcId?: InputMaybe<Scalars['String']>;
  signed?: InputMaybe<Scalars['Boolean']>;
};

export type UserUpdateResponse = {
  __typename?: 'UserUpdateResponse';
  data?: Maybe<User>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type Visit = CollectionDataInterface & {
  __typename?: 'Visit';
  Item?: Maybe<Item>;
  User?: Maybe<User>;
  _id: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  itemId?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  media?: Maybe<Array<File>>;
  nfcId: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
  userId: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
};

export type VisitCreateResponse = {
  __typename?: 'VisitCreateResponse';
  data?: Maybe<Visit>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type VisitDeleteResponse = {
  __typename?: 'VisitDeleteResponse';
  data?: Maybe<Visit>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type VisitInput = {
  itemId?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  media?: InputMaybe<Array<FileDocInput>>;
  nfcId: Scalars['String'];
  userId: Scalars['String'];
  userName?: InputMaybe<Scalars['String']>;
};

export type VisitUpdateResponse = {
  __typename?: 'VisitUpdateResponse';
  data?: Maybe<Visit>;
  error?: Maybe<InputError>;
  message?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type _FileFilter = {
  AND?: InputMaybe<Array<_FileFilter>>;
  OR?: InputMaybe<Array<_FileFilter>>;
  _id__eq?: InputMaybe<Scalars['String']>;
  _id__in?: InputMaybe<Array<Scalars['String']>>;
  _id__not_eq?: InputMaybe<Scalars['String']>;
  _id__not_in?: InputMaybe<Array<Scalars['String']>>;
  createdAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  description__contains?: InputMaybe<Scalars['String']>;
  description__eq?: InputMaybe<Scalars['String']>;
  description__not_contains?: InputMaybe<Scalars['String']>;
  description__not_eq?: InputMaybe<Scalars['String']>;
  elemMatch?: InputMaybe<_FileFilter>;
  fileType__eq?: InputMaybe<Scalars['String']>;
  fileType__in?: InputMaybe<Array<Scalars['String']>>;
  fileType__not_eq?: InputMaybe<Scalars['String']>;
  fileType__not_in?: InputMaybe<Array<Scalars['String']>>;
  isDeleted__eq?: InputMaybe<Scalars['Boolean']>;
  isDeleted__not_eq?: InputMaybe<Scalars['Boolean']>;
  name__contains?: InputMaybe<Scalars['String']>;
  name__eq?: InputMaybe<Scalars['String']>;
  name__in?: InputMaybe<Array<Scalars['String']>>;
  name__not_contains?: InputMaybe<Scalars['String']>;
  name__not_eq?: InputMaybe<Scalars['String']>;
  name__not_in?: InputMaybe<Array<Scalars['String']>>;
  type__contains?: InputMaybe<Scalars['String']>;
  type__eq?: InputMaybe<Scalars['String']>;
  type__in?: InputMaybe<Array<Scalars['String']>>;
  type__not_contains?: InputMaybe<Scalars['String']>;
  type__not_eq?: InputMaybe<Scalars['String']>;
  type__not_in?: InputMaybe<Array<Scalars['String']>>;
  updatedAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  userId__eq?: InputMaybe<Scalars['String']>;
  userId__not_eq?: InputMaybe<Scalars['String']>;
};

/** Auto generated sort type */
export enum _FileSort {
  IdAsc = '_id__asc',
  IdDesc = '_id__desc',
  CreatedAtAsc = 'createdAt__asc',
  CreatedAtDesc = 'createdAt__desc',
  DescriptionAsc = 'description__asc',
  DescriptionDesc = 'description__desc',
  FileTypeAsc = 'fileType__asc',
  FileTypeDesc = 'fileType__desc',
  NameAsc = 'name__asc',
  NameDesc = 'name__desc',
  UpdatedAtAsc = 'updatedAt__asc',
  UpdatedAtDesc = 'updatedAt__desc'
}

export type _ItemFilter = {
  AND?: InputMaybe<Array<_ItemFilter>>;
  OR?: InputMaybe<Array<_ItemFilter>>;
  _id__eq?: InputMaybe<Scalars['String']>;
  _id__in?: InputMaybe<Array<Scalars['String']>>;
  _id__not_eq?: InputMaybe<Scalars['String']>;
  _id__not_in?: InputMaybe<Array<Scalars['String']>>;
  address_de__contains?: InputMaybe<Scalars['String']>;
  address_de__eq?: InputMaybe<Scalars['String']>;
  address_de__not_eq?: InputMaybe<Scalars['String']>;
  address_en__contains?: InputMaybe<Scalars['String']>;
  address_en__eq?: InputMaybe<Scalars['String']>;
  address_en__not_eq?: InputMaybe<Scalars['String']>;
  address_fr__contains?: InputMaybe<Scalars['String']>;
  address_fr__eq?: InputMaybe<Scalars['String']>;
  address_fr__not_eq?: InputMaybe<Scalars['String']>;
  address_hi__contains?: InputMaybe<Scalars['String']>;
  address_hi__eq?: InputMaybe<Scalars['String']>;
  address_hi__not_eq?: InputMaybe<Scalars['String']>;
  address_ja__contains?: InputMaybe<Scalars['String']>;
  address_ja__eq?: InputMaybe<Scalars['String']>;
  address_ja__not_eq?: InputMaybe<Scalars['String']>;
  address_ko__contains?: InputMaybe<Scalars['String']>;
  address_ko__eq?: InputMaybe<Scalars['String']>;
  address_ko__not_eq?: InputMaybe<Scalars['String']>;
  address_zh__contains?: InputMaybe<Scalars['String']>;
  address_zh__eq?: InputMaybe<Scalars['String']>;
  address_zh__not_eq?: InputMaybe<Scalars['String']>;
  categoryKey__eq?: InputMaybe<Category>;
  categoryKey__in?: InputMaybe<Array<Category>>;
  categoryKey__not_eq?: InputMaybe<Category>;
  createdAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  elemMatch?: InputMaybe<_ItemFilter>;
  information_de__contains?: InputMaybe<Scalars['String']>;
  information_de__eq?: InputMaybe<Scalars['String']>;
  information_de__not_eq?: InputMaybe<Scalars['String']>;
  information_en__contains?: InputMaybe<Scalars['String']>;
  information_en__eq?: InputMaybe<Scalars['String']>;
  information_en__not_eq?: InputMaybe<Scalars['String']>;
  information_fr__contains?: InputMaybe<Scalars['String']>;
  information_fr__eq?: InputMaybe<Scalars['String']>;
  information_fr__not_eq?: InputMaybe<Scalars['String']>;
  information_hi__contains?: InputMaybe<Scalars['String']>;
  information_hi__eq?: InputMaybe<Scalars['String']>;
  information_hi__not_eq?: InputMaybe<Scalars['String']>;
  information_ja__contains?: InputMaybe<Scalars['String']>;
  information_ja__eq?: InputMaybe<Scalars['String']>;
  information_ja__not_eq?: InputMaybe<Scalars['String']>;
  information_ko__contains?: InputMaybe<Scalars['String']>;
  information_ko__eq?: InputMaybe<Scalars['String']>;
  information_ko__not_eq?: InputMaybe<Scalars['String']>;
  information_zh__contains?: InputMaybe<Scalars['String']>;
  information_zh__eq?: InputMaybe<Scalars['String']>;
  information_zh__not_eq?: InputMaybe<Scalars['String']>;
  isDeleted__eq?: InputMaybe<Scalars['Boolean']>;
  isDeleted__not_eq?: InputMaybe<Scalars['Boolean']>;
  name_de__contains?: InputMaybe<Scalars['String']>;
  name_de__eq?: InputMaybe<Scalars['String']>;
  name_de__not_eq?: InputMaybe<Scalars['String']>;
  name_en__contains?: InputMaybe<Scalars['String']>;
  name_en__eq?: InputMaybe<Scalars['String']>;
  name_en__not_eq?: InputMaybe<Scalars['String']>;
  name_fr__contains?: InputMaybe<Scalars['String']>;
  name_fr__eq?: InputMaybe<Scalars['String']>;
  name_fr__not_eq?: InputMaybe<Scalars['String']>;
  name_hi__contains?: InputMaybe<Scalars['String']>;
  name_hi__eq?: InputMaybe<Scalars['String']>;
  name_hi__not_eq?: InputMaybe<Scalars['String']>;
  name_ja__contains?: InputMaybe<Scalars['String']>;
  name_ja__eq?: InputMaybe<Scalars['String']>;
  name_ja__not_eq?: InputMaybe<Scalars['String']>;
  name_ko__contains?: InputMaybe<Scalars['String']>;
  name_ko__eq?: InputMaybe<Scalars['String']>;
  name_ko__not_eq?: InputMaybe<Scalars['String']>;
  name_zh__contains?: InputMaybe<Scalars['String']>;
  name_zh__eq?: InputMaybe<Scalars['String']>;
  name_zh__not_eq?: InputMaybe<Scalars['String']>;
  updatedAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
};

/** Auto generated sort type */
export enum _ItemSort {
  IdAsc = '_id__asc',
  IdDesc = '_id__desc',
  CreatedAtAsc = 'createdAt__asc',
  CreatedAtDesc = 'createdAt__desc',
  UpdatedAtAsc = 'updatedAt__asc',
  UpdatedAtDesc = 'updatedAt__desc'
}

export type _SystemNotiFilter = {
  AND?: InputMaybe<Array<_SystemNotiFilter>>;
  OR?: InputMaybe<Array<_SystemNotiFilter>>;
  _id__eq?: InputMaybe<Scalars['String']>;
  _id__in?: InputMaybe<Array<Scalars['String']>>;
  _id__not_eq?: InputMaybe<Scalars['String']>;
  _id__not_in?: InputMaybe<Array<Scalars['String']>>;
  createdAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  elemMatch?: InputMaybe<_SystemNotiFilter>;
  info_itemCategory__eq?: InputMaybe<Scalars['String']>;
  info_itemCategory__in?: InputMaybe<Array<Scalars['String']>>;
  info_itemCategory__not_eq?: InputMaybe<Scalars['String']>;
  info_itemId__eq?: InputMaybe<Scalars['String']>;
  info_itemId__in?: InputMaybe<Array<Scalars['String']>>;
  info_itemId__not_eq?: InputMaybe<Scalars['String']>;
  isDeleted__eq?: InputMaybe<Scalars['Boolean']>;
  isDeleted__not_eq?: InputMaybe<Scalars['Boolean']>;
  type__eq?: InputMaybe<Scalars['String']>;
  type__not_eq?: InputMaybe<Scalars['String']>;
  updatedAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
};

/** Auto generated sort type */
export enum _SystemNotiSort {
  IdAsc = '_id__asc',
  IdDesc = '_id__desc',
  CreatedAtAsc = 'createdAt__asc',
  CreatedAtDesc = 'createdAt__desc',
  TypeAsc = 'type__asc',
  TypeDesc = 'type__desc',
  UpdatedAtAsc = 'updatedAt__asc',
  UpdatedAtDesc = 'updatedAt__desc'
}

export type _UserFilter = {
  AND?: InputMaybe<Array<_UserFilter>>;
  OR?: InputMaybe<Array<_UserFilter>>;
  _id__eq?: InputMaybe<Scalars['String']>;
  _id__in?: InputMaybe<Array<Scalars['String']>>;
  _id__not_eq?: InputMaybe<Scalars['String']>;
  _id__not_in?: InputMaybe<Array<Scalars['String']>>;
  age__eq?: InputMaybe<Scalars['String']>;
  age__in?: InputMaybe<Array<Scalars['String']>>;
  age__not_eq?: InputMaybe<Scalars['String']>;
  country__eq?: InputMaybe<Scalars['String']>;
  country__in?: InputMaybe<Array<Scalars['String']>>;
  country__not_eq?: InputMaybe<Scalars['String']>;
  createdAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  elemMatch?: InputMaybe<_UserFilter>;
  isDeleted__eq?: InputMaybe<Scalars['Boolean']>;
  isDeleted__not_eq?: InputMaybe<Scalars['Boolean']>;
  langeCode__eq?: InputMaybe<Scalars['String']>;
  langeCode__in?: InputMaybe<Array<Scalars['String']>>;
  langeCode__not_eq?: InputMaybe<Scalars['String']>;
  mid__eq?: InputMaybe<Scalars['String']>;
  mid__not_eq?: InputMaybe<Scalars['String']>;
  name__contains?: InputMaybe<Scalars['String']>;
  name__eq?: InputMaybe<Scalars['String']>;
  name__not_eq?: InputMaybe<Scalars['String']>;
  nfcId__eq?: InputMaybe<Scalars['String']>;
  nfcId__not_eq?: InputMaybe<Scalars['String']>;
  signed__eq?: InputMaybe<Scalars['String']>;
  signed__not_eq?: InputMaybe<Scalars['String']>;
  updatedAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
};

/** Auto generated sort type */
export enum _UserSort {
  IdAsc = '_id__asc',
  IdDesc = '_id__desc',
  CreatedAtAsc = 'createdAt__asc',
  CreatedAtDesc = 'createdAt__desc',
  UpdatedAtAsc = 'updatedAt__asc',
  UpdatedAtDesc = 'updatedAt__desc'
}

export type _VisitFilter = {
  AND?: InputMaybe<Array<_VisitFilter>>;
  OR?: InputMaybe<Array<_VisitFilter>>;
  _id__eq?: InputMaybe<Scalars['String']>;
  _id__in?: InputMaybe<Array<Scalars['String']>>;
  _id__not_eq?: InputMaybe<Scalars['String']>;
  _id__not_in?: InputMaybe<Array<Scalars['String']>>;
  createdAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  createdAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  elemMatch?: InputMaybe<_VisitFilter>;
  isDeleted__eq?: InputMaybe<Scalars['Boolean']>;
  isDeleted__not_eq?: InputMaybe<Scalars['Boolean']>;
  itemId__eq?: InputMaybe<Scalars['String']>;
  itemId__in?: InputMaybe<Array<Scalars['String']>>;
  itemId__not_eq?: InputMaybe<Scalars['String']>;
  itemName__contains?: InputMaybe<Scalars['String']>;
  itemName__eq?: InputMaybe<Scalars['String']>;
  itemName__not_eq?: InputMaybe<Scalars['String']>;
  nfcId__eq?: InputMaybe<Scalars['String']>;
  nfcId__not_eq?: InputMaybe<Scalars['String']>;
  updatedAt__eq?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__gte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lt?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__lte?: InputMaybe<Scalars['DateTimeISO']>;
  updatedAt__not_eq?: InputMaybe<Scalars['DateTimeISO']>;
  userName__contains?: InputMaybe<Scalars['String']>;
  userName__eq?: InputMaybe<Scalars['String']>;
  userName__not_eq?: InputMaybe<Scalars['String']>;
};

/** Auto generated sort type */
export enum _VisitSort {
  IdAsc = '_id__asc',
  IdDesc = '_id__desc',
  CreatedAtAsc = 'createdAt__asc',
  CreatedAtDesc = 'createdAt__desc',
  UpdatedAtAsc = 'updatedAt__asc',
  UpdatedAtDesc = 'updatedAt__desc'
}

export type FadminFragment = { __typename?: 'Admin', name: string, _id: string, createdAt: any, updatedAt: any };

export type SignInMutationVariables = Exact<{
  password: Scalars['String'];
  name: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', SignIn: { __typename?: 'SignInResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null, data?: { __typename?: 'Admin', name: string, _id: string, createdAt: any, updatedAt: any } | null } };

export type AdminQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminQuery = { __typename?: 'Query', Admin?: { __typename?: 'Admin', name: string, _id: string, createdAt: any, updatedAt: any } | null };

export type FboucherFragment = { __typename?: 'Boucher', title: any, subText: any, file?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null };

type FcollectionDataInterface_Admin_Fragment = { __typename?: 'Admin', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_Coupon_Fragment = { __typename?: 'Coupon', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_File_Fragment = { __typename?: 'File', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_Item_Fragment = { __typename?: 'Item', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_SystemNoti_Fragment = { __typename?: 'SystemNoti', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_User_Fragment = { __typename?: 'User', _id: string, createdAt: any, updatedAt: any };

type FcollectionDataInterface_Visit_Fragment = { __typename?: 'Visit', _id: string, createdAt: any, updatedAt: any };

export type FcollectionDataInterfaceFragment = FcollectionDataInterface_Admin_Fragment | FcollectionDataInterface_Coupon_Fragment | FcollectionDataInterface_File_Fragment | FcollectionDataInterface_Item_Fragment | FcollectionDataInterface_SystemNoti_Fragment | FcollectionDataInterface_User_Fragment | FcollectionDataInterface_Visit_Fragment;

export type FinputErrorFragment = { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null };

export type FoffsetPagingInfoFragment = { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number };

export type FsystemNotiFragment = { __typename?: 'SystemNoti', _id: string, createdAt: any, updatedAt: any, type: SystemNotiType, content?: string | null, isRead: boolean, severity: SystemNotiSeverity, info?: { __typename?: 'SystemNotiInfo', itemId?: string | null, itemCategory?: string | null, itemName?: any | null, couponName?: any | null } | null };

export type FcouponFragment = { __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null };

export type CouponUseMutationVariables = Exact<{
  couponId: Scalars['String'];
  itemId: Scalars['String'];
}>;


export type CouponUseMutation = { __typename?: 'Mutation', CouponUse: { __typename?: 'CouponResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null, data?: { __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null } | null } };

export type FfileFragment = { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> };

export type FileUploadsMutationVariables = Exact<{
  files: Array<FileInput> | FileInput;
  gallery?: InputMaybe<Scalars['Boolean']>;
}>;


export type FileUploadsMutation = { __typename?: 'Mutation', FileUploads: { __typename?: 'FileUploadsResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null, data: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } };

export type FileListQueryVariables = Exact<{
  sort?: InputMaybe<Array<_FileSort> | _FileSort>;
  filter?: InputMaybe<_FileFilter>;
  pagingInput: OffsetPagingInput;
}>;


export type FileListQuery = { __typename?: 'Query', FileList: { __typename?: 'OffsetPagenatedFileData', pageInfo?: { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number } | null, items: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } };

export type FileDeletesMutationVariables = Exact<{
  deleteFileList: Array<Scalars['ObjectId']> | Scalars['ObjectId'];
}>;


export type FileDeletesMutation = { __typename?: 'Mutation', FileDeletes: { __typename?: 'Response', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type FitemDetailFragment = { __typename?: 'Item', boothId?: string | null, type: ItemType, name: any, categoryKey?: Category | null, contact?: string | null, information: any, address?: any | null, lat?: number | null, lng?: number | null, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, coupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null, addressDetail?: { __typename?: 'DetailLocation', lng?: number | null, lat?: number | null, addressDetail?: string | null, zonecode?: string | null, address?: string | null, addressEnglish?: string | null, addressType?: string | null, userSelectedType?: string | null, noSelected?: string | null, userLanguageType?: string | null, roadAddress?: string | null, roadAddressEnglish?: string | null, jibunAddress?: string | null, jibunAddressEnglish?: string | null, autoRoadAddress?: string | null, autoRoadAddressEnglish?: string | null, autoJibunAddress?: string | null, autoJibunAddressEnglish?: string | null, buildingCode?: string | null, buildingName?: string | null, apartment?: string | null, sido?: string | null, sidoEnglish?: string | null, sigungu?: string | null, sigunguEnglish?: string | null, sigunguCode?: string | null, roadnameCode?: string | null, bcode?: string | null, roadname?: string | null, roadnameEnglish?: string | null, bname?: string | null, bnameEnglish?: string | null, bname1?: string | null, bname1English?: string | null, bname2?: string | null, bname2English?: string | null, hname?: string | null, query?: string | null, postcode?: string | null, postcode1?: string | null, postcode2?: string | null, postcodeSeq?: string | null } | null, bouchers?: Array<{ __typename?: 'Boucher', title: any, subText: any, file?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null, shorts?: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null };

export type FitemFragment = { __typename?: 'Item', name: any, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> };

export type ItemUpdateMutationVariables = Exact<{
  input: ItemInput;
  itemId: Scalars['String'];
}>;


export type ItemUpdateMutation = { __typename?: 'Mutation', ItemUpdate: { __typename?: 'ItemUpdateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type ItemCreateMutationVariables = Exact<{
  input: ItemInput;
}>;


export type ItemCreateMutation = { __typename?: 'Mutation', ItemCreate: { __typename?: 'ItemCreateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type ItemDeleteMutationVariables = Exact<{
  itemId: Scalars['String'];
}>;


export type ItemDeleteMutation = { __typename?: 'Mutation', ItemDelete: { __typename?: 'ItemDeleteResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type ItemFindByIdQueryVariables = Exact<{
  itemId: Scalars['String'];
  selectAll: Scalars['Boolean'];
}>;


export type ItemFindByIdQuery = { __typename?: 'Query', ItemFindById?: { __typename?: 'Item', boothId?: string | null, type: ItemType, name: any, categoryKey?: Category | null, contact?: string | null, information: any, address?: any | null, lat?: number | null, lng?: number | null, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }>, coupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null, addressDetail?: { __typename?: 'DetailLocation', lng?: number | null, lat?: number | null, addressDetail?: string | null, zonecode?: string | null, address?: string | null, addressEnglish?: string | null, addressType?: string | null, userSelectedType?: string | null, noSelected?: string | null, userLanguageType?: string | null, roadAddress?: string | null, roadAddressEnglish?: string | null, jibunAddress?: string | null, jibunAddressEnglish?: string | null, autoRoadAddress?: string | null, autoRoadAddressEnglish?: string | null, autoJibunAddress?: string | null, autoJibunAddressEnglish?: string | null, buildingCode?: string | null, buildingName?: string | null, apartment?: string | null, sido?: string | null, sidoEnglish?: string | null, sigungu?: string | null, sigunguEnglish?: string | null, sigunguCode?: string | null, roadnameCode?: string | null, bcode?: string | null, roadname?: string | null, roadnameEnglish?: string | null, bname?: string | null, bnameEnglish?: string | null, bname1?: string | null, bname1English?: string | null, bname2?: string | null, bname2English?: string | null, hname?: string | null, query?: string | null, postcode?: string | null, postcode1?: string | null, postcode2?: string | null, postcodeSeq?: string | null } | null, bouchers?: Array<{ __typename?: 'Boucher', title: any, subText: any, file?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null, shorts?: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null } | null };

export type ItemFindByPathQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ItemFindByPathQuery = { __typename?: 'Query', ItemFindByPath?: { __typename?: 'Item', name: any, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } | null };

export type ItemFindByStoreIdQueryVariables = Exact<{
  storeId: Scalars['String'];
}>;


export type ItemFindByStoreIdQuery = { __typename?: 'Query', ItemFindByStoreId?: { __typename?: 'Item', name: any, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> } | null };

export type ItemListQueryVariables = Exact<{
  sort?: InputMaybe<Array<_ItemSort> | _ItemSort>;
  filter?: InputMaybe<_ItemFilter>;
  pagingInput: OffsetPagingInput;
}>;


export type ItemListQuery = { __typename?: 'Query', ItemList: { __typename?: 'OffsetPagenatedItemData', pageInfo?: { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number } | null, items: Array<{ __typename?: 'Item', name: any, _id: string, createdAt: any, updatedAt: any, image: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> }> } };

export type FitemMapFragment = { __typename?: 'ItemMap', _id: string, name: string, boothId: string, categoryKey: string, lat: number, lng: number };

export type ItemMapQueryVariables = Exact<{
  sort?: InputMaybe<Array<_ItemSort> | _ItemSort>;
  filter?: InputMaybe<_ItemFilter>;
}>;


export type ItemMapQuery = { __typename?: 'Query', ItemMap: Array<{ __typename?: 'ItemMap', _id: string, name: string, boothId: string, categoryKey: string, lat: number, lng: number }> };

export type FdetailLocationFragment = { __typename?: 'DetailLocation', lng?: number | null, lat?: number | null, addressDetail?: string | null, zonecode?: string | null, address?: string | null, addressEnglish?: string | null, addressType?: string | null, userSelectedType?: string | null, noSelected?: string | null, userLanguageType?: string | null, roadAddress?: string | null, roadAddressEnglish?: string | null, jibunAddress?: string | null, jibunAddressEnglish?: string | null, autoRoadAddress?: string | null, autoRoadAddressEnglish?: string | null, autoJibunAddress?: string | null, autoJibunAddressEnglish?: string | null, buildingCode?: string | null, buildingName?: string | null, apartment?: string | null, sido?: string | null, sidoEnglish?: string | null, sigungu?: string | null, sigunguEnglish?: string | null, sigunguCode?: string | null, roadnameCode?: string | null, bcode?: string | null, roadname?: string | null, roadnameEnglish?: string | null, bname?: string | null, bnameEnglish?: string | null, bname1?: string | null, bname1English?: string | null, bname2?: string | null, bname2English?: string | null, hname?: string | null, query?: string | null, postcode?: string | null, postcode1?: string | null, postcode2?: string | null, postcodeSeq?: string | null };

export type SystemNotiListQueryVariables = Exact<{
  sort?: InputMaybe<Array<_SystemNotiSort> | _SystemNotiSort>;
  filter?: InputMaybe<_SystemNotiFilter>;
  pagingInput: OffsetPagingInput;
}>;


export type SystemNotiListQuery = { __typename?: 'Query', SystemNotiList: { __typename?: 'OffsetPagenatedSystemNotiData', pageInfo?: { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number } | null, items: Array<{ __typename?: 'SystemNoti', _id: string, createdAt: any, updatedAt: any, type: SystemNotiType, content?: string | null, isRead: boolean, severity: SystemNotiSeverity, info?: { __typename?: 'SystemNotiInfo', itemId?: string | null, itemCategory?: string | null, itemName?: any | null, couponName?: any | null } | null }> } };

export type UnReadNotiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UnReadNotiesQuery = { __typename?: 'Query', UnReadNoties: Array<string> };

export type SystemNotiReadMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type SystemNotiReadMutation = { __typename?: 'Mutation', SystemNotiRead: { __typename?: 'SystemNotiReadResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type SystemNotiHideMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type SystemNotiHideMutation = { __typename?: 'Mutation', SystemNotiHide: { __typename?: 'SystemNotiHideResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type SystemNotiCreateMutationVariables = Exact<{
  message: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  serverity?: InputMaybe<SystemNotiSeverity>;
}>;


export type SystemNotiCreateMutation = { __typename?: 'Mutation', SystemNotiCreate: { __typename?: 'SystemNotiCreateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type FuserFragment = { __typename?: 'User', unReadSystemNoties?: Array<any> | null, type?: string | null, nfcId?: string | null, country?: string | null, age?: string | null, name?: string | null, signed?: boolean | null, langeCode?: string | null, visitCnt?: number | null, _id: string, createdAt: any, updatedAt: any, busiCard?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, Visits?: Array<{ __typename?: 'Visit', itemId?: string | null }> | null, useCoupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null };

export type UserCreateOrFindQueryVariables = Exact<{
  input: UserInput;
}>;


export type UserCreateOrFindQuery = { __typename?: 'Query', UserCreateOrFind: { __typename?: 'UserCreateOrFindResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null, data?: { __typename?: 'User', unReadSystemNoties?: Array<any> | null, type?: string | null, nfcId?: string | null, country?: string | null, age?: string | null, name?: string | null, signed?: boolean | null, langeCode?: string | null, visitCnt?: number | null, _id: string, createdAt: any, updatedAt: any, busiCard?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, Visits?: Array<{ __typename?: 'Visit', itemId?: string | null }> | null, useCoupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null } | null } };

export type UserFindByNfcIdQueryVariables = Exact<{
  nfcId: Scalars['String'];
}>;


export type UserFindByNfcIdQuery = { __typename?: 'Query', UserFindByNfcId?: { __typename?: 'User', unReadSystemNoties?: Array<any> | null, type?: string | null, nfcId?: string | null, country?: string | null, age?: string | null, name?: string | null, signed?: boolean | null, langeCode?: string | null, visitCnt?: number | null, _id: string, createdAt: any, updatedAt: any, busiCard?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, Visits?: Array<{ __typename?: 'Visit', itemId?: string | null }> | null, useCoupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null } | null };

export type UserUpdateMutationVariables = Exact<{
  input: UserInput;
  userId: Scalars['String'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', UserUpdate: { __typename?: 'UserUpdateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type UserDeleteMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserDeleteMutation = { __typename?: 'Mutation', UserDelete: { __typename?: 'UserDeleteResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type LangSetMutationVariables = Exact<{
  langCode: Scalars['String'];
}>;


export type LangSetMutation = { __typename?: 'Mutation', LangSet: { __typename?: 'UserUpdateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type UserListQueryVariables = Exact<{
  sort?: InputMaybe<Array<_UserSort> | _UserSort>;
  filter?: InputMaybe<_UserFilter>;
  pagingInput: OffsetPagingInput;
}>;


export type UserListQuery = { __typename?: 'Query', UserList: { __typename?: 'OffsetPagenatedUserData', pageInfo?: { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number } | null, items: Array<{ __typename?: 'User', unReadSystemNoties?: Array<any> | null, type?: string | null, nfcId?: string | null, country?: string | null, age?: string | null, name?: string | null, signed?: boolean | null, langeCode?: string | null, visitCnt?: number | null, _id: string, createdAt: any, updatedAt: any, busiCard?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null, Visits?: Array<{ __typename?: 'Visit', itemId?: string | null }> | null, useCoupon?: Array<{ __typename?: 'Coupon', _id: string, title: any, subText: any, used?: number | null, itemId?: string | null, photo?: { __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> } | null }> | null }> } };

export type FvisitFragment = { __typename?: 'Visit', itemId?: string | null, userId: string, nfcId: string, _id: string, createdAt: any, updatedAt: any, media?: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null };

export type VisitCreateMutationVariables = Exact<{
  input: VisitInput;
}>;


export type VisitCreateMutation = { __typename?: 'Mutation', VisitCreate: { __typename?: 'VisitCreateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type VisitUpdateMutationVariables = Exact<{
  input: VisitInput;
  visitId: Scalars['String'];
}>;


export type VisitUpdateMutation = { __typename?: 'Mutation', VisitUpdate: { __typename?: 'VisitUpdateResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type VisitDeleteMutationVariables = Exact<{
  visitId: Scalars['String'];
}>;


export type VisitDeleteMutation = { __typename?: 'Mutation', VisitDelete: { __typename?: 'VisitDeleteResponse', ok: boolean, error?: { __typename?: 'InputError', code: string, message: string, details?: Array<string> | null } | null } };

export type VisitListQueryVariables = Exact<{
  sort?: InputMaybe<Array<_VisitSort> | _VisitSort>;
  filter?: InputMaybe<_VisitFilter>;
  pagingInput: OffsetPagingInput;
}>;


export type VisitListQuery = { __typename?: 'Query', VisitList: { __typename?: 'OffsetPagenatedVisitData', pageInfo?: { __typename?: 'OffsetPagingInfo', pageIndex: number, pageItemCount: number, currentItemCount: number, totalPageCount: number, totalDocumentCount: number } | null, items: Array<{ __typename?: 'Visit', itemId?: string | null, userId: string, nfcId: string, _id: string, createdAt: any, updatedAt: any, media?: Array<{ __typename?: 'File', name: string, description?: string | null, extension: string, fileType?: string | null, uri: string, blur?: string | null, _id: string, createdAt: any, updatedAt: any, tags: Array<{ __typename?: 'Tag', key: string, value: string }> }> | null }> } };

export const FcollectionDataInterfaceFragmentDoc = gql`
    fragment FcollectionDataInterface on CollectionDataInterface {
  _id
  createdAt
  updatedAt
}
    `;
export const FadminFragmentDoc = gql`
    fragment Fadmin on Admin {
  ...FcollectionDataInterface
  name
}
    ${FcollectionDataInterfaceFragmentDoc}`;
export const FinputErrorFragmentDoc = gql`
    fragment FinputError on InputError {
  code
  message
  details
}
    `;
export const FoffsetPagingInfoFragmentDoc = gql`
    fragment FoffsetPagingInfo on OffsetPagingInfo {
  pageIndex
  pageItemCount
  currentItemCount
  totalPageCount
  totalDocumentCount
}
    `;
export const FsystemNotiFragmentDoc = gql`
    fragment FsystemNoti on SystemNoti {
  _id
  createdAt
  updatedAt
  type
  content
  isRead
  severity
  info {
    itemId
    itemCategory
    itemName
    couponName
  }
}
    `;
export const FfileFragmentDoc = gql`
    fragment Ffile on File {
  ...FcollectionDataInterface
  name
  description
  extension
  fileType
  uri
  blur
  tags {
    key
    value
  }
}
    ${FcollectionDataInterfaceFragmentDoc}`;
export const FcouponFragmentDoc = gql`
    fragment Fcoupon on Coupon {
  _id
  title
  subText
  photo {
    ...Ffile
  }
  used
  itemId
}
    ${FfileFragmentDoc}`;
export const FdetailLocationFragmentDoc = gql`
    fragment FdetailLocation on DetailLocation {
  lng
  lat
  addressDetail
  zonecode
  address
  addressEnglish
  addressType
  userSelectedType
  noSelected
  userLanguageType
  roadAddress
  roadAddressEnglish
  jibunAddress
  jibunAddressEnglish
  autoRoadAddress
  autoRoadAddressEnglish
  autoJibunAddress
  autoJibunAddressEnglish
  buildingCode
  buildingName
  apartment
  sido
  sidoEnglish
  sigungu
  sigunguEnglish
  sigunguCode
  roadnameCode
  bcode
  roadname
  roadnameEnglish
  bname
  bnameEnglish
  bname1
  bname1English
  bname2
  bname2English
  hname
  query
  postcode
  postcode1
  postcode2
  postcodeSeq
}
    `;
export const FboucherFragmentDoc = gql`
    fragment Fboucher on Boucher {
  title
  subText
  file {
    ...Ffile
  }
}
    ${FfileFragmentDoc}`;
export const FitemDetailFragmentDoc = gql`
    fragment FitemDetail on Item {
  ...FcollectionDataInterface
  boothId
  image {
    ...Ffile
  }
  type
  name
  categoryKey
  contact
  information
  address
  coupon {
    ...Fcoupon
  }
  addressDetail {
    ...FdetailLocation
  }
  bouchers {
    ...Fboucher
  }
  shorts {
    ...Ffile
  }
  lat
  lng
}
    ${FcollectionDataInterfaceFragmentDoc}
${FfileFragmentDoc}
${FcouponFragmentDoc}
${FdetailLocationFragmentDoc}
${FboucherFragmentDoc}`;
export const FitemFragmentDoc = gql`
    fragment Fitem on Item {
  ...FcollectionDataInterface
  image {
    ...Ffile
  }
  name
}
    ${FcollectionDataInterfaceFragmentDoc}
${FfileFragmentDoc}`;
export const FitemMapFragmentDoc = gql`
    fragment FitemMap on ItemMap {
  _id
  name
  boothId
  categoryKey
  lat
  lng
}
    `;
export const FuserFragmentDoc = gql`
    fragment Fuser on User {
  ...FcollectionDataInterface
  unReadSystemNoties
  type
  nfcId
  country
  age
  name
  signed
  langeCode
  busiCard {
    ...Ffile
  }
  Visits {
    itemId
  }
  useCoupon {
    ...Fcoupon
  }
  visitCnt
}
    ${FcollectionDataInterfaceFragmentDoc}
${FfileFragmentDoc}
${FcouponFragmentDoc}`;
export const FvisitFragmentDoc = gql`
    fragment Fvisit on Visit {
  ...FcollectionDataInterface
  itemId
  userId
  nfcId
  media {
    ...Ffile
  }
}
    ${FcollectionDataInterfaceFragmentDoc}
${FfileFragmentDoc}`;
export const SignInDocument = gql`
    mutation signIn($password: String!, $name: String!) {
  SignIn(password: $password, name: $name) {
    ok
    error {
      ...FinputError
    }
    data {
      ...Fadmin
    }
  }
}
    ${FinputErrorFragmentDoc}
${FadminFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      password: // value for 'password'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const AdminDocument = gql`
    query admin {
  Admin {
    ...Fadmin
  }
}
    ${FadminFragmentDoc}`;

/**
 * __useAdminQuery__
 *
 * To run a query within a React component, call `useAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminQuery(baseOptions?: Apollo.QueryHookOptions<AdminQuery, AdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
      }
export function useAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminQuery, AdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminQuery, AdminQueryVariables>(AdminDocument, options);
        }
export type AdminQueryHookResult = ReturnType<typeof useAdminQuery>;
export type AdminLazyQueryHookResult = ReturnType<typeof useAdminLazyQuery>;
export type AdminQueryResult = Apollo.QueryResult<AdminQuery, AdminQueryVariables>;
export const CouponUseDocument = gql`
    mutation couponUse($couponId: String!, $itemId: String!) {
  CouponUse(couponId: $couponId, itemId: $itemId) {
    ok
    error {
      ...FinputError
    }
    data {
      ...Fcoupon
    }
  }
}
    ${FinputErrorFragmentDoc}
${FcouponFragmentDoc}`;
export type CouponUseMutationFn = Apollo.MutationFunction<CouponUseMutation, CouponUseMutationVariables>;

/**
 * __useCouponUseMutation__
 *
 * To run a mutation, you first call `useCouponUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponUseMutation, { data, loading, error }] = useCouponUseMutation({
 *   variables: {
 *      couponId: // value for 'couponId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useCouponUseMutation(baseOptions?: Apollo.MutationHookOptions<CouponUseMutation, CouponUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponUseMutation, CouponUseMutationVariables>(CouponUseDocument, options);
      }
export type CouponUseMutationHookResult = ReturnType<typeof useCouponUseMutation>;
export type CouponUseMutationResult = Apollo.MutationResult<CouponUseMutation>;
export type CouponUseMutationOptions = Apollo.BaseMutationOptions<CouponUseMutation, CouponUseMutationVariables>;
export const FileUploadsDocument = gql`
    mutation fileUploads($files: [FileInput!]!, $gallery: Boolean) {
  FileUploads(files: $files, gallery: $gallery) {
    ok
    error {
      ...FinputError
    }
    data {
      ...Ffile
    }
  }
}
    ${FinputErrorFragmentDoc}
${FfileFragmentDoc}`;
export type FileUploadsMutationFn = Apollo.MutationFunction<FileUploadsMutation, FileUploadsMutationVariables>;

/**
 * __useFileUploadsMutation__
 *
 * To run a mutation, you first call `useFileUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUploadsMutation, { data, loading, error }] = useFileUploadsMutation({
 *   variables: {
 *      files: // value for 'files'
 *      gallery: // value for 'gallery'
 *   },
 * });
 */
export function useFileUploadsMutation(baseOptions?: Apollo.MutationHookOptions<FileUploadsMutation, FileUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUploadsMutation, FileUploadsMutationVariables>(FileUploadsDocument, options);
      }
export type FileUploadsMutationHookResult = ReturnType<typeof useFileUploadsMutation>;
export type FileUploadsMutationResult = Apollo.MutationResult<FileUploadsMutation>;
export type FileUploadsMutationOptions = Apollo.BaseMutationOptions<FileUploadsMutation, FileUploadsMutationVariables>;
export const FileListDocument = gql`
    query fileList($sort: [_FileSort!], $filter: _FileFilter, $pagingInput: OffsetPagingInput!) {
  FileList(sort: $sort, pagingInput: $pagingInput, filter: $filter) {
    pageInfo {
      ...FoffsetPagingInfo
    }
    items {
      ...Ffile
    }
  }
}
    ${FoffsetPagingInfoFragmentDoc}
${FfileFragmentDoc}`;

/**
 * __useFileListQuery__
 *
 * To run a query within a React component, call `useFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useFileListQuery(baseOptions: Apollo.QueryHookOptions<FileListQuery, FileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileListQuery, FileListQueryVariables>(FileListDocument, options);
      }
export function useFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileListQuery, FileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileListQuery, FileListQueryVariables>(FileListDocument, options);
        }
export type FileListQueryHookResult = ReturnType<typeof useFileListQuery>;
export type FileListLazyQueryHookResult = ReturnType<typeof useFileListLazyQuery>;
export type FileListQueryResult = Apollo.QueryResult<FileListQuery, FileListQueryVariables>;
export const FileDeletesDocument = gql`
    mutation fileDeletes($deleteFileList: [ObjectId!]!) {
  FileDeletes(deleteFileList: $deleteFileList) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type FileDeletesMutationFn = Apollo.MutationFunction<FileDeletesMutation, FileDeletesMutationVariables>;

/**
 * __useFileDeletesMutation__
 *
 * To run a mutation, you first call `useFileDeletesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileDeletesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileDeletesMutation, { data, loading, error }] = useFileDeletesMutation({
 *   variables: {
 *      deleteFileList: // value for 'deleteFileList'
 *   },
 * });
 */
export function useFileDeletesMutation(baseOptions?: Apollo.MutationHookOptions<FileDeletesMutation, FileDeletesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileDeletesMutation, FileDeletesMutationVariables>(FileDeletesDocument, options);
      }
export type FileDeletesMutationHookResult = ReturnType<typeof useFileDeletesMutation>;
export type FileDeletesMutationResult = Apollo.MutationResult<FileDeletesMutation>;
export type FileDeletesMutationOptions = Apollo.BaseMutationOptions<FileDeletesMutation, FileDeletesMutationVariables>;
export const ItemUpdateDocument = gql`
    mutation itemUpdate($input: ItemInput!, $itemId: String!) {
  ItemUpdate(itemId: $itemId, input: $input) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type ItemUpdateMutationFn = Apollo.MutationFunction<ItemUpdateMutation, ItemUpdateMutationVariables>;

/**
 * __useItemUpdateMutation__
 *
 * To run a mutation, you first call `useItemUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItemUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itemUpdateMutation, { data, loading, error }] = useItemUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useItemUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ItemUpdateMutation, ItemUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItemUpdateMutation, ItemUpdateMutationVariables>(ItemUpdateDocument, options);
      }
export type ItemUpdateMutationHookResult = ReturnType<typeof useItemUpdateMutation>;
export type ItemUpdateMutationResult = Apollo.MutationResult<ItemUpdateMutation>;
export type ItemUpdateMutationOptions = Apollo.BaseMutationOptions<ItemUpdateMutation, ItemUpdateMutationVariables>;
export const ItemCreateDocument = gql`
    mutation itemCreate($input: ItemInput!) {
  ItemCreate(input: $input) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type ItemCreateMutationFn = Apollo.MutationFunction<ItemCreateMutation, ItemCreateMutationVariables>;

/**
 * __useItemCreateMutation__
 *
 * To run a mutation, you first call `useItemCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItemCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itemCreateMutation, { data, loading, error }] = useItemCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useItemCreateMutation(baseOptions?: Apollo.MutationHookOptions<ItemCreateMutation, ItemCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItemCreateMutation, ItemCreateMutationVariables>(ItemCreateDocument, options);
      }
export type ItemCreateMutationHookResult = ReturnType<typeof useItemCreateMutation>;
export type ItemCreateMutationResult = Apollo.MutationResult<ItemCreateMutation>;
export type ItemCreateMutationOptions = Apollo.BaseMutationOptions<ItemCreateMutation, ItemCreateMutationVariables>;
export const ItemDeleteDocument = gql`
    mutation itemDelete($itemId: String!) {
  ItemDelete(itemId: $itemId) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type ItemDeleteMutationFn = Apollo.MutationFunction<ItemDeleteMutation, ItemDeleteMutationVariables>;

/**
 * __useItemDeleteMutation__
 *
 * To run a mutation, you first call `useItemDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItemDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itemDeleteMutation, { data, loading, error }] = useItemDeleteMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useItemDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ItemDeleteMutation, ItemDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItemDeleteMutation, ItemDeleteMutationVariables>(ItemDeleteDocument, options);
      }
export type ItemDeleteMutationHookResult = ReturnType<typeof useItemDeleteMutation>;
export type ItemDeleteMutationResult = Apollo.MutationResult<ItemDeleteMutation>;
export type ItemDeleteMutationOptions = Apollo.BaseMutationOptions<ItemDeleteMutation, ItemDeleteMutationVariables>;
export const ItemFindByIdDocument = gql`
    query itemFindById($itemId: String!, $selectAll: Boolean!) {
  ItemFindById(itemId: $itemId, selectAll: $selectAll) {
    ...FitemDetail
  }
}
    ${FitemDetailFragmentDoc}`;

/**
 * __useItemFindByIdQuery__
 *
 * To run a query within a React component, call `useItemFindByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemFindByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemFindByIdQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      selectAll: // value for 'selectAll'
 *   },
 * });
 */
export function useItemFindByIdQuery(baseOptions: Apollo.QueryHookOptions<ItemFindByIdQuery, ItemFindByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemFindByIdQuery, ItemFindByIdQueryVariables>(ItemFindByIdDocument, options);
      }
export function useItemFindByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemFindByIdQuery, ItemFindByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemFindByIdQuery, ItemFindByIdQueryVariables>(ItemFindByIdDocument, options);
        }
export type ItemFindByIdQueryHookResult = ReturnType<typeof useItemFindByIdQuery>;
export type ItemFindByIdLazyQueryHookResult = ReturnType<typeof useItemFindByIdLazyQuery>;
export type ItemFindByIdQueryResult = Apollo.QueryResult<ItemFindByIdQuery, ItemFindByIdQueryVariables>;
export const ItemFindByPathDocument = gql`
    query itemFindByPath($path: String!) {
  ItemFindByPath(path: $path) {
    ...Fitem
  }
}
    ${FitemFragmentDoc}`;

/**
 * __useItemFindByPathQuery__
 *
 * To run a query within a React component, call `useItemFindByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemFindByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemFindByPathQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useItemFindByPathQuery(baseOptions: Apollo.QueryHookOptions<ItemFindByPathQuery, ItemFindByPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemFindByPathQuery, ItemFindByPathQueryVariables>(ItemFindByPathDocument, options);
      }
export function useItemFindByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemFindByPathQuery, ItemFindByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemFindByPathQuery, ItemFindByPathQueryVariables>(ItemFindByPathDocument, options);
        }
export type ItemFindByPathQueryHookResult = ReturnType<typeof useItemFindByPathQuery>;
export type ItemFindByPathLazyQueryHookResult = ReturnType<typeof useItemFindByPathLazyQuery>;
export type ItemFindByPathQueryResult = Apollo.QueryResult<ItemFindByPathQuery, ItemFindByPathQueryVariables>;
export const ItemFindByStoreIdDocument = gql`
    query itemFindByStoreId($storeId: String!) {
  ItemFindByStoreId(storeId: $storeId) {
    ...Fitem
  }
}
    ${FitemFragmentDoc}`;

/**
 * __useItemFindByStoreIdQuery__
 *
 * To run a query within a React component, call `useItemFindByStoreIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemFindByStoreIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemFindByStoreIdQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useItemFindByStoreIdQuery(baseOptions: Apollo.QueryHookOptions<ItemFindByStoreIdQuery, ItemFindByStoreIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemFindByStoreIdQuery, ItemFindByStoreIdQueryVariables>(ItemFindByStoreIdDocument, options);
      }
export function useItemFindByStoreIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemFindByStoreIdQuery, ItemFindByStoreIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemFindByStoreIdQuery, ItemFindByStoreIdQueryVariables>(ItemFindByStoreIdDocument, options);
        }
export type ItemFindByStoreIdQueryHookResult = ReturnType<typeof useItemFindByStoreIdQuery>;
export type ItemFindByStoreIdLazyQueryHookResult = ReturnType<typeof useItemFindByStoreIdLazyQuery>;
export type ItemFindByStoreIdQueryResult = Apollo.QueryResult<ItemFindByStoreIdQuery, ItemFindByStoreIdQueryVariables>;
export const ItemListDocument = gql`
    query itemList($sort: [_ItemSort!], $filter: _ItemFilter, $pagingInput: OffsetPagingInput!) {
  ItemList(sort: $sort, pagingInput: $pagingInput, filter: $filter) {
    pageInfo {
      ...FoffsetPagingInfo
    }
    items {
      ...Fitem
    }
  }
}
    ${FoffsetPagingInfoFragmentDoc}
${FitemFragmentDoc}`;

/**
 * __useItemListQuery__
 *
 * To run a query within a React component, call `useItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useItemListQuery(baseOptions: Apollo.QueryHookOptions<ItemListQuery, ItemListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemListQuery, ItemListQueryVariables>(ItemListDocument, options);
      }
export function useItemListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemListQuery, ItemListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemListQuery, ItemListQueryVariables>(ItemListDocument, options);
        }
export type ItemListQueryHookResult = ReturnType<typeof useItemListQuery>;
export type ItemListLazyQueryHookResult = ReturnType<typeof useItemListLazyQuery>;
export type ItemListQueryResult = Apollo.QueryResult<ItemListQuery, ItemListQueryVariables>;
export const ItemMapDocument = gql`
    query itemMap($sort: [_ItemSort!], $filter: _ItemFilter) {
  ItemMap(sort: $sort, filter: $filter) {
    ...FitemMap
  }
}
    ${FitemMapFragmentDoc}`;

/**
 * __useItemMapQuery__
 *
 * To run a query within a React component, call `useItemMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMapQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemMapQuery(baseOptions?: Apollo.QueryHookOptions<ItemMapQuery, ItemMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemMapQuery, ItemMapQueryVariables>(ItemMapDocument, options);
      }
export function useItemMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemMapQuery, ItemMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemMapQuery, ItemMapQueryVariables>(ItemMapDocument, options);
        }
export type ItemMapQueryHookResult = ReturnType<typeof useItemMapQuery>;
export type ItemMapLazyQueryHookResult = ReturnType<typeof useItemMapLazyQuery>;
export type ItemMapQueryResult = Apollo.QueryResult<ItemMapQuery, ItemMapQueryVariables>;
export const SystemNotiListDocument = gql`
    query systemNotiList($sort: [_SystemNotiSort!], $filter: _SystemNotiFilter, $pagingInput: OffsetPagingInput!) {
  SystemNotiList(sort: $sort, pagingInput: $pagingInput, filter: $filter) {
    pageInfo {
      ...FoffsetPagingInfo
    }
    items {
      ...FsystemNoti
    }
  }
}
    ${FoffsetPagingInfoFragmentDoc}
${FsystemNotiFragmentDoc}`;

/**
 * __useSystemNotiListQuery__
 *
 * To run a query within a React component, call `useSystemNotiListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotiListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotiListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useSystemNotiListQuery(baseOptions: Apollo.QueryHookOptions<SystemNotiListQuery, SystemNotiListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemNotiListQuery, SystemNotiListQueryVariables>(SystemNotiListDocument, options);
      }
export function useSystemNotiListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemNotiListQuery, SystemNotiListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemNotiListQuery, SystemNotiListQueryVariables>(SystemNotiListDocument, options);
        }
export type SystemNotiListQueryHookResult = ReturnType<typeof useSystemNotiListQuery>;
export type SystemNotiListLazyQueryHookResult = ReturnType<typeof useSystemNotiListLazyQuery>;
export type SystemNotiListQueryResult = Apollo.QueryResult<SystemNotiListQuery, SystemNotiListQueryVariables>;
export const UnReadNotiesDocument = gql`
    query unReadNoties {
  UnReadNoties
}
    `;

/**
 * __useUnReadNotiesQuery__
 *
 * To run a query within a React component, call `useUnReadNotiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnReadNotiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnReadNotiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnReadNotiesQuery(baseOptions?: Apollo.QueryHookOptions<UnReadNotiesQuery, UnReadNotiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnReadNotiesQuery, UnReadNotiesQueryVariables>(UnReadNotiesDocument, options);
      }
export function useUnReadNotiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnReadNotiesQuery, UnReadNotiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnReadNotiesQuery, UnReadNotiesQueryVariables>(UnReadNotiesDocument, options);
        }
export type UnReadNotiesQueryHookResult = ReturnType<typeof useUnReadNotiesQuery>;
export type UnReadNotiesLazyQueryHookResult = ReturnType<typeof useUnReadNotiesLazyQuery>;
export type UnReadNotiesQueryResult = Apollo.QueryResult<UnReadNotiesQuery, UnReadNotiesQueryVariables>;
export const SystemNotiReadDocument = gql`
    mutation systemNotiRead($ids: [String!]!) {
  SystemNotiRead(ids: $ids) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type SystemNotiReadMutationFn = Apollo.MutationFunction<SystemNotiReadMutation, SystemNotiReadMutationVariables>;

/**
 * __useSystemNotiReadMutation__
 *
 * To run a mutation, you first call `useSystemNotiReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemNotiReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemNotiReadMutation, { data, loading, error }] = useSystemNotiReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSystemNotiReadMutation(baseOptions?: Apollo.MutationHookOptions<SystemNotiReadMutation, SystemNotiReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemNotiReadMutation, SystemNotiReadMutationVariables>(SystemNotiReadDocument, options);
      }
export type SystemNotiReadMutationHookResult = ReturnType<typeof useSystemNotiReadMutation>;
export type SystemNotiReadMutationResult = Apollo.MutationResult<SystemNotiReadMutation>;
export type SystemNotiReadMutationOptions = Apollo.BaseMutationOptions<SystemNotiReadMutation, SystemNotiReadMutationVariables>;
export const SystemNotiHideDocument = gql`
    mutation systemNotiHide($ids: [String!]!) {
  SystemNotiHide(ids: $ids) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type SystemNotiHideMutationFn = Apollo.MutationFunction<SystemNotiHideMutation, SystemNotiHideMutationVariables>;

/**
 * __useSystemNotiHideMutation__
 *
 * To run a mutation, you first call `useSystemNotiHideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemNotiHideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemNotiHideMutation, { data, loading, error }] = useSystemNotiHideMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSystemNotiHideMutation(baseOptions?: Apollo.MutationHookOptions<SystemNotiHideMutation, SystemNotiHideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemNotiHideMutation, SystemNotiHideMutationVariables>(SystemNotiHideDocument, options);
      }
export type SystemNotiHideMutationHookResult = ReturnType<typeof useSystemNotiHideMutation>;
export type SystemNotiHideMutationResult = Apollo.MutationResult<SystemNotiHideMutation>;
export type SystemNotiHideMutationOptions = Apollo.BaseMutationOptions<SystemNotiHideMutation, SystemNotiHideMutationVariables>;
export const SystemNotiCreateDocument = gql`
    mutation SystemNotiCreate($message: String!, $userIds: [String!], $serverity: SystemNotiSeverity) {
  SystemNotiCreate(message: $message, userIds: $userIds, serverity: $serverity) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type SystemNotiCreateMutationFn = Apollo.MutationFunction<SystemNotiCreateMutation, SystemNotiCreateMutationVariables>;

/**
 * __useSystemNotiCreateMutation__
 *
 * To run a mutation, you first call `useSystemNotiCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemNotiCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemNotiCreateMutation, { data, loading, error }] = useSystemNotiCreateMutation({
 *   variables: {
 *      message: // value for 'message'
 *      userIds: // value for 'userIds'
 *      serverity: // value for 'serverity'
 *   },
 * });
 */
export function useSystemNotiCreateMutation(baseOptions?: Apollo.MutationHookOptions<SystemNotiCreateMutation, SystemNotiCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemNotiCreateMutation, SystemNotiCreateMutationVariables>(SystemNotiCreateDocument, options);
      }
export type SystemNotiCreateMutationHookResult = ReturnType<typeof useSystemNotiCreateMutation>;
export type SystemNotiCreateMutationResult = Apollo.MutationResult<SystemNotiCreateMutation>;
export type SystemNotiCreateMutationOptions = Apollo.BaseMutationOptions<SystemNotiCreateMutation, SystemNotiCreateMutationVariables>;
export const UserCreateOrFindDocument = gql`
    query userCreateOrFind($input: UserInput!) {
  UserCreateOrFind(input: $input) {
    ok
    error {
      ...FinputError
    }
    data {
      ...Fuser
    }
  }
}
    ${FinputErrorFragmentDoc}
${FuserFragmentDoc}`;

/**
 * __useUserCreateOrFindQuery__
 *
 * To run a query within a React component, call `useUserCreateOrFindQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreateOrFindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreateOrFindQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateOrFindQuery(baseOptions: Apollo.QueryHookOptions<UserCreateOrFindQuery, UserCreateOrFindQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCreateOrFindQuery, UserCreateOrFindQueryVariables>(UserCreateOrFindDocument, options);
      }
export function useUserCreateOrFindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCreateOrFindQuery, UserCreateOrFindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCreateOrFindQuery, UserCreateOrFindQueryVariables>(UserCreateOrFindDocument, options);
        }
export type UserCreateOrFindQueryHookResult = ReturnType<typeof useUserCreateOrFindQuery>;
export type UserCreateOrFindLazyQueryHookResult = ReturnType<typeof useUserCreateOrFindLazyQuery>;
export type UserCreateOrFindQueryResult = Apollo.QueryResult<UserCreateOrFindQuery, UserCreateOrFindQueryVariables>;
export const UserFindByNfcIdDocument = gql`
    query userFindByNfcId($nfcId: String!) {
  UserFindByNfcId(nfcId: $nfcId) {
    ...Fuser
  }
}
    ${FuserFragmentDoc}`;

/**
 * __useUserFindByNfcIdQuery__
 *
 * To run a query within a React component, call `useUserFindByNfcIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindByNfcIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindByNfcIdQuery({
 *   variables: {
 *      nfcId: // value for 'nfcId'
 *   },
 * });
 */
export function useUserFindByNfcIdQuery(baseOptions: Apollo.QueryHookOptions<UserFindByNfcIdQuery, UserFindByNfcIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindByNfcIdQuery, UserFindByNfcIdQueryVariables>(UserFindByNfcIdDocument, options);
      }
export function useUserFindByNfcIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindByNfcIdQuery, UserFindByNfcIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindByNfcIdQuery, UserFindByNfcIdQueryVariables>(UserFindByNfcIdDocument, options);
        }
export type UserFindByNfcIdQueryHookResult = ReturnType<typeof useUserFindByNfcIdQuery>;
export type UserFindByNfcIdLazyQueryHookResult = ReturnType<typeof useUserFindByNfcIdLazyQuery>;
export type UserFindByNfcIdQueryResult = Apollo.QueryResult<UserFindByNfcIdQuery, UserFindByNfcIdQueryVariables>;
export const UserUpdateDocument = gql`
    mutation userUpdate($input: UserInput!, $userId: String!) {
  UserUpdate(userId: $userId, input: $input) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserDeleteDocument = gql`
    mutation userDelete($userId: String!) {
  UserDelete(userId: $userId) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type UserDeleteMutationFn = Apollo.MutationFunction<UserDeleteMutation, UserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument, options);
      }
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<UserDeleteMutation, UserDeleteMutationVariables>;
export const LangSetDocument = gql`
    mutation langSet($langCode: String!) {
  LangSet(langCode: $langCode) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type LangSetMutationFn = Apollo.MutationFunction<LangSetMutation, LangSetMutationVariables>;

/**
 * __useLangSetMutation__
 *
 * To run a mutation, you first call `useLangSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLangSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [langSetMutation, { data, loading, error }] = useLangSetMutation({
 *   variables: {
 *      langCode: // value for 'langCode'
 *   },
 * });
 */
export function useLangSetMutation(baseOptions?: Apollo.MutationHookOptions<LangSetMutation, LangSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LangSetMutation, LangSetMutationVariables>(LangSetDocument, options);
      }
export type LangSetMutationHookResult = ReturnType<typeof useLangSetMutation>;
export type LangSetMutationResult = Apollo.MutationResult<LangSetMutation>;
export type LangSetMutationOptions = Apollo.BaseMutationOptions<LangSetMutation, LangSetMutationVariables>;
export const UserListDocument = gql`
    query userList($sort: [_UserSort!], $filter: _UserFilter, $pagingInput: OffsetPagingInput!) {
  UserList(sort: $sort, pagingInput: $pagingInput, filter: $filter) {
    pageInfo {
      ...FoffsetPagingInfo
    }
    items {
      ...Fuser
    }
  }
}
    ${FoffsetPagingInfoFragmentDoc}
${FuserFragmentDoc}`;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const VisitCreateDocument = gql`
    mutation visitCreate($input: VisitInput!) {
  VisitCreate(input: $input) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type VisitCreateMutationFn = Apollo.MutationFunction<VisitCreateMutation, VisitCreateMutationVariables>;

/**
 * __useVisitCreateMutation__
 *
 * To run a mutation, you first call `useVisitCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitCreateMutation, { data, loading, error }] = useVisitCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisitCreateMutation(baseOptions?: Apollo.MutationHookOptions<VisitCreateMutation, VisitCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitCreateMutation, VisitCreateMutationVariables>(VisitCreateDocument, options);
      }
export type VisitCreateMutationHookResult = ReturnType<typeof useVisitCreateMutation>;
export type VisitCreateMutationResult = Apollo.MutationResult<VisitCreateMutation>;
export type VisitCreateMutationOptions = Apollo.BaseMutationOptions<VisitCreateMutation, VisitCreateMutationVariables>;
export const VisitUpdateDocument = gql`
    mutation visitUpdate($input: VisitInput!, $visitId: String!) {
  VisitUpdate(visitId: $visitId, input: $input) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type VisitUpdateMutationFn = Apollo.MutationFunction<VisitUpdateMutation, VisitUpdateMutationVariables>;

/**
 * __useVisitUpdateMutation__
 *
 * To run a mutation, you first call `useVisitUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitUpdateMutation, { data, loading, error }] = useVisitUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useVisitUpdateMutation(baseOptions?: Apollo.MutationHookOptions<VisitUpdateMutation, VisitUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitUpdateMutation, VisitUpdateMutationVariables>(VisitUpdateDocument, options);
      }
export type VisitUpdateMutationHookResult = ReturnType<typeof useVisitUpdateMutation>;
export type VisitUpdateMutationResult = Apollo.MutationResult<VisitUpdateMutation>;
export type VisitUpdateMutationOptions = Apollo.BaseMutationOptions<VisitUpdateMutation, VisitUpdateMutationVariables>;
export const VisitDeleteDocument = gql`
    mutation visitDelete($visitId: String!) {
  VisitDelete(visitId: $visitId) {
    ok
    error {
      ...FinputError
    }
  }
}
    ${FinputErrorFragmentDoc}`;
export type VisitDeleteMutationFn = Apollo.MutationFunction<VisitDeleteMutation, VisitDeleteMutationVariables>;

/**
 * __useVisitDeleteMutation__
 *
 * To run a mutation, you first call `useVisitDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitDeleteMutation, { data, loading, error }] = useVisitDeleteMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useVisitDeleteMutation(baseOptions?: Apollo.MutationHookOptions<VisitDeleteMutation, VisitDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitDeleteMutation, VisitDeleteMutationVariables>(VisitDeleteDocument, options);
      }
export type VisitDeleteMutationHookResult = ReturnType<typeof useVisitDeleteMutation>;
export type VisitDeleteMutationResult = Apollo.MutationResult<VisitDeleteMutation>;
export type VisitDeleteMutationOptions = Apollo.BaseMutationOptions<VisitDeleteMutation, VisitDeleteMutationVariables>;
export const VisitListDocument = gql`
    query visitList($sort: [_VisitSort!], $filter: _VisitFilter, $pagingInput: OffsetPagingInput!) {
  VisitList(sort: $sort, pagingInput: $pagingInput, filter: $filter) {
    pageInfo {
      ...FoffsetPagingInfo
    }
    items {
      ...Fvisit
    }
  }
}
    ${FoffsetPagingInfoFragmentDoc}
${FvisitFragmentDoc}`;

/**
 * __useVisitListQuery__
 *
 * To run a query within a React component, call `useVisitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitListQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      pagingInput: // value for 'pagingInput'
 *   },
 * });
 */
export function useVisitListQuery(baseOptions: Apollo.QueryHookOptions<VisitListQuery, VisitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitListQuery, VisitListQueryVariables>(VisitListDocument, options);
      }
export function useVisitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitListQuery, VisitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitListQuery, VisitListQueryVariables>(VisitListDocument, options);
        }
export type VisitListQueryHookResult = ReturnType<typeof useVisitListQuery>;
export type VisitListLazyQueryHookResult = ReturnType<typeof useVisitListLazyQuery>;
export type VisitListQueryResult = Apollo.QueryResult<VisitListQuery, VisitListQueryVariables>;